module.exports = __webpack_public_path__ + "img/0100_wood_01.9c003757.png";